import { defineStore } from 'pinia'
import { useLocalStorage } from '@vueuse/core'
import { computed } from 'vue'

export const useAuth = defineStore('auth', () => {
  const username = useLocalStorage('auth/username', null)
  const id = useLocalStorage('auth/id', null)
  const observer = useLocalStorage('auth/observer', false)
  const isLoggedIn = computed(() => !!id.value)
  return {
    id,
    username,
    observer,
    isLoggedIn
  }
})
